import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';
import { SocialMedia } from '../../../../layouts/Main/components/Sidebar/components/';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Contact</Typography>
          <Typography className={classes.description} >Interested in hiring me for your project or just want to say hi? You can fill in the contact form below or send me an email to <Link component="a" href={'mailto:davibaltarx.npm@gmail.com'}>davibaltarx.npm@gmail.com</Link></Typography>
          <Typography className={classes.description} >Want to get connected? Follow me on the social channels below.</Typography>
          <div style={{ textAlign: 'center' }}>
            <SocialMedia />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};


export default Header;